import _ from 'lodash'

export const OpportunityDates = {
  data() {
    return {
      now: new Date(),
    }
  },

  computed: {
    closingDate() {
      return this.getClosingDate(this.opportunity)
    },

    isOpportunityOpen() {
      return this.getIsOpportunityOpen(this.opportunity)
    },

    isOpportunityClosed() {
      return this.getIsOpportunityClosed(this.opportunity)
    },

    isReferred() {
      return this.getIsReferred(this.eligibility)
    },

    opportunityDeadline() {
      return this.getOpportunityDeadline(this.opportunity)
    },

    openingDate() {
      return this.getOpeningDate(this.opportunity)
    },

    opportunityDateColor() {
      return this.getOpportunityDateColor(this.opportunity)
    },

    timeToClosingDate() {
      return this.getTimeToClosingDate(this.opportunity)
    },

    timeToOpeningDate() {
      return this.getTimeToOpeningDate(this.opportunity)
    },

    willOpportunityOpen() {
      return this.getWillOpportunityOpen(this.opportunity)
    },
  },

  methods: {
    getClosingDate(opportunity) {
      if (!opportunity || !opportunity.closesAt) return null

      return new Date(opportunity.closesAt)
    },

    getIsOpportunityOpen(opportunity) {
      if (!opportunity) return false

      return !!(
        this.getOpeningDate(opportunity) &&
        this.getOpeningDate(opportunity) < this.now &&
        this.getOpportunityDeadline(opportunity) &&
        this.getOpportunityDeadline(opportunity) > this.now
      )
    },

    getIsOpportunityClosed(opportunity) {
      return !this.getIsOpportunityOpen(opportunity)
    },

    getIsReferred(eligibility) {
      return eligibility && !!eligibility.referredAt
    },

    getOpportunityDeadline(opportunity) {
      const date = this.getIsReferred(opportunity)
        ? opportunity.commencesAt || opportunity.closesAt
        : opportunity.closesAt

      return date ? new Date(date) : null
    },

    getOpeningDate(opportunity) {
      if (!opportunity || !opportunity.opensAt) return null

      return new Date(opportunity.opensAt)
    },

    getOpportunityDateColor(opportunity) {
      if (this.getWillOpportunityOpen(opportunity)) return 'primary'
      if (this.getIsOpportunityOpen(opportunity)) return 'success'
      return 'muted'
    },

    getTimeToOpeningDate(opportunity) {
      const diffDays = parseInt(
        (this.getOpeningDate(opportunity) - this.now) / (1000 * 60 * 60 * 24)
      )

      if (diffDays >= 0 && diffDays <= 35) {
        return `${parseInt(diffDays)} ${diffDays > 1 ? 'days' : 'day'}`
      }

      return this.$inWords(this.getOpeningDate(opportunity))
    },

    getTimeToClosingDate(opportunity) {
      const diffDays = parseInt(
        (this.getClosingDate(opportunity) - this.now) / (1000 * 60 * 60 * 24)
      )

      if (diffDays >= 0 && diffDays <= 35) {
        return `${parseInt(diffDays)} ${diffDays > 1 ? 'days' : 'day'}`
      }

      return this.$inWords(this.getClosingDate(opportunity))
    },

    getWillOpportunityOpen(opportunity) {
      if (!opportunity) return false

      return !!(opportunity.opensAt && new Date(opportunity.opensAt) > this.now)
    },
  },
}

export default {
  OpportunityDates,
}
